<div class="pt-3" *ngIf="loadingOrgConfig">
  <h2>Loading...</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pl-md-4 pt-4 pb-5" *ngIf="!loadingOrgConfig && (serverError === null)">
  <div class="row">
    <div class="col-lg-8">
      <h3>Configure Linking Accounts</h3>
      <p>
        Linking accounts allows customers to purchase group memberships, and allows adults to manage their children's account information.
      </p>

      <div class="form-group mt-4">
        <label for="customerFacingInput">
          Customer facing linking instructions *
        </label>
        <textarea class="form-control" id="customerFacingInput" rows="5"
                  [(ngModel)]="orgConfig.customer_facing_linking_instructions"></textarea>
        <small class="form-text text-muted">
          Include information concerning your gym/centre's rules for linking customer accounts, as well as any information you may request to verify the relationship.
        </small>
        <div class="form-text text-danger">
          {{ errors.customer_facing_linking_instructions }}
        </div>
      </div>

      <div class="form-group">
        <label for="staffFacingInput">
          Staff verification instructions *
        </label>
        <textarea class="form-control" id="staffFacingInput" rows="5"
                  [(ngModel)]="orgConfig.staff_verification_linking_instructions"></textarea>
        <small class="form-text text-muted">
          Include information your staff may need to know in order to determine whether to approve a link between two customer accounts.
        </small>
        <div class="form-text text-danger">
          {{ errors.staff_verification_linking_instructions }}
        </div>
      </div>

      <div class="form-group">
        <label class="mb-1">Select the "relations" a customer can choose:</label>
        <div class="form-check ml-3">
          <input class="form-check-input" type="checkbox" id="relationSpouseCheckbox"
                 [(ngModel)]="orgConfig.spouse_relation_allowed">
          <label class="form-check-label" for="relationSpouseCheckbox">
            Spouse
          </label>
        </div>
        <div class="form-check ml-3">
          <input class="form-check-input" type="checkbox" id="relationPartnerCheckbox"
                 [(ngModel)]="orgConfig.partner_relation_allowed">
          <label class="form-check-label" for="relationPartnerCheckbox">
            Partner
          </label>
        </div>
        <div class="form-check ml-3">
          <input class="form-check-input" type="checkbox" id="relationParentChildCheckbox"
                 [(ngModel)]="parentChildRelationAllowed">
          <label class="form-check-label" for="relationParentChildCheckbox">
            Parent / Child
          </label>
        </div>
        <div class="form-check ml-3">
          <input class="form-check-input" type="checkbox" id="relationLegalGuardianWardCheckbox"
                 [(ngModel)]="legalGuardianWardRelationAllowed">
          <label class="form-check-label" for="relationLegalGuardianWardCheckbox">
            Legal Guardian / Legal Ward
          </label>
        </div>
        <div class="form-check ml-3">
          <input class="form-check-input" type="checkbox" id="relationGuardianWardCheckbox"
                 [(ngModel)]="guardianWardRelationAllowed">
          <label class="form-check-label" for="relationGuardianWardCheckbox">
            Guardian / Ward
          </label>
        </div>
        <div class="form-check ml-3">
          <input class="form-check-input" type="checkbox" id="relationSiblingCheckbox"
                 [(ngModel)]="orgConfig.sibling_relation_allowed">
          <label class="form-check-label" for="relationSiblingCheckbox">
            Sibling
          </label>
        </div>
        <div class="form-check ml-3">
          <input class="form-check-input" type="checkbox" id="relationOtherCheckbox"
                 [(ngModel)]="orgConfig.other_relation_allowed">
          <label class="form-check-label" for="relationOtherCheckbox">
            Other
          </label>
        </div>
      </div>

      <div class="form-group mt-4">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="allowEntryPassLinkingCheckbox"
                 [(ngModel)]="orgConfig.allow_entry_pass_linking">
          <label class="form-check-label" for="allowEntryPassLinkingCheckbox">
            Allow entry passes to be linked to multiple customers
          </label>
        </div>
        <small class="form-text text-muted">
          This enables staff to link additional customers to an entry pass, allowing the pass to be shared amongst
          families, couples, etc. Entry passes owned by associations may always be linked by staff to specific
          association members.
        </small>
      </div>

      <div class="form-group" *ngIf="orgConfig.allow_entry_pass_linking">
        <label for="entryPassLinkingInstructionsInput">
          Staff instructions for entry pass linking
        </label>
        <textarea class="form-control" id="entryPassLinkingInstructionsInput" rows="5"
                  [(ngModel)]="orgConfig.entry_pass_linking_instructions"></textarea>
        <small class="form-text text-muted">
          Include information your staff may need to know when linking entry passes.
        </small>
        <div class="form-text text-danger">
          {{ errors.entry_pass_linking_instructions }}
        </div>
      </div>

      <div class="mt-4">
        <div class="alert alert-success" role="alert" *ngIf="successMessage">
          {{ successMessage }}
        </div>

        <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
          {{ errors.non_field_errors }}
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>

        <button class="btn btn-primary float-right"
                *ngIf="!savingOrgConfig"
                (click)="saveOrganizationConfig()">
          Save
        </button>
        <button class="btn btn-primary float-right disabled" disabled
                *ngIf="savingOrgConfig">
          Loading...
        </button>
        <button class="btn btn-secondary" (click)="loadOrganizationConfig()">
          Cancel
        </button>
      </div>

    </div>
  </div>
</div>
